import React from 'react';

import { NRTDatePicker } from 'features/task_bar/DatePicker';
import { SlowdownThresholdSlider } from 'features/task_bar/SlowdownThresholdSlider';

import { ComparisonPicker } from '../task_bar/ComparisonPicker';

export function ChartSettings() {
  return (
    <div>
      <NRTDatePicker />
      <ComparisonPicker enableDayRange />
      <SlowdownThresholdSlider />
    </div>
  );
}
